// @flow

// Vendors
import React from 'react';

// Hooks
import { useTranslate } from '../../hooks';

// Types
type Props = {
  handleInputChange: Function
};

const ProjectsFilters = ({
  values,
  categories,
  handleInputChange,
  handleSubmit,
  resetFilter,
  showProjects,
  categoryPageData
}: Props) => {
  const { searchFieldPlaceholder, searchButtonLabel } = useTranslate({
    searchFieldPlaceholder: `Search ${
      categoryPageData ? `${categoryPageData.title} ` : ''
    }Projects`,
    searchButtonLabel: 'Search'
  });

  return (
    <section onSubmit={handleSubmit} className="section section--sm">
      <div className="container">
        <form className="filters">
          <div className="filters__search-field form__field">
            <input
              name="search"
              type="search"
              value={values.search}
              className="form__input"
              placeholder={searchFieldPlaceholder}
              onChange={handleInputChange}
            />
            {values.search && (
              <button
                type="button"
                className="form__field__clear"
                onClick={() => resetFilter('search')}
              />
            )}
          </div>

          {showProjects && categories.length > 0 && (
            <div className="filters__categories-field form__field">
              <div className="form__select">
                <select
                  name="category"
                  value={values.category}
                  onChange={handleInputChange}
                >
                  <option value="">Categories&hellip;</option>
                  {categories.map(category => (
                    <option key={category.id} value={category.id}>
                      {category.title}
                    </option>
                  ))}
                </select>
                {values.category && (
                  <button
                    type="button"
                    className="form__field__clear"
                    onClick={() => resetFilter('category')}
                  />
                )}
              </div>
            </div>
          )}

          <button type="submit" className="btn btn--primary">
            {searchButtonLabel}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ProjectsFilters;
